import styled from "@emotion/styled";
import { IconContainer } from "../../styles";

export const IconWarning = styled.div`
  top: ${({ theme }) => theme.coefficient * 24}px;
  right: ${({ theme }) => theme.coefficient * 40}px;
  height: ${({ theme }) => theme.coefficient * 24}px;
  width: ${({ theme }) => theme.coefficient * 24}px;
  background-image: ${({ theme }) => `url(${theme.images.info_var_3})`};
  background-size: auto;
  background-repeat: no-repeat;
  background-position: center;
`;

export const IconContainerWarning = styled(IconContainer)`
  & svg circle {
    fill: ${({ theme }) => theme.colors.value_36};
  }
  & svg path {
    stroke: ${({ theme }) => theme.colors.value_01};
  }
`;
